import Head from "expo-router/head";
import { useContext } from "react";

import { LayoutContext, ScrollView } from "@/components";
import { SAMS_CLUB_EVENTS } from "@/config/adConversionEvents";
import { brandName } from "@/config/brand";
import Glp1LandingPage, {
  type Glp1PartnerDisplay,
} from "@/landing-page/glp1/Glp1LandingPage";

const PARTNER_DISPLAY: Glp1PartnerDisplay = {
  name: "Sam's Club",
  brandColor: "$samsClubBlue",
  trackingEvent: SAMS_CLUB_EVENTS.visitedGlp1SplashScreen,
  providerId: "SC_CURAI",
  announcementCopy:
    "Introductory offer: Free visits for Sam's Club members until November 30th †",
  heroOfferCopy: "Free visits for Sam's Club members until November 30th †",
  welcomeChipSuffix: "members",
  showPromoDisclaimer: true,
};

export default function Glp1ProgramPage() {
  const { headerHeight } = useContext(LayoutContext);

  return (
    <>
      <Head>
        <title>{`GLP-1 Program — ${brandName}`}</title>
      </Head>
      <ScrollView
        contentContainerStyle={{
          flexGrow: 1,
          paddingTop: headerHeight.current,
        }}
        keyboardShouldPersistTaps="handled"
        showsVerticalScrollIndicator={false}
        backgroundColor="$backgroundGround"
      >
        <Glp1LandingPage partnerDisplay={PARTNER_DISPLAY} />
      </ScrollView>
    </>
  );
}
